import { createIsomorphicFn } from "@tanstack/react-start";
import type { SocialMetadata } from "~/lib/social-metadata";
import { getRequestRuntime } from "./request-runtime.server";

export interface DocumentMetadata {
  iconPreloadHref?: string;
  socialImageHref?: string;
  canonicalHref: string | null;
  languageTag: string;
  socialMetadata: SocialMetadata | null;
}

export const getDocumentMetadata = createIsomorphicFn()
  .server(() => getRequestRuntime().documentMetadata)
  .client((): DocumentMetadata | undefined => undefined);
